import { inject, Injectable } from '@angular/core';
import { FirebaseService } from '../../../../../../common/firebase/firebase.service';
import { ChatGptService } from '../../../../../../services/chat-gpt/chat-gpt.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { GptCompletionMessage } from '../../../../../../common/general-types/open-ai.dto';
import { UgcProductResponseDto } from '../../../../../../common/general-types/products.dto';

@Injectable({
  providedIn: 'root'
})
export class IcpSearchService {

  private chatGptService = inject(ChatGptService);
  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  async openAiCreatorProfileSearch(brandName: string, briefTitle: string, product: UgcProductResponseDto, goal: { id: number, name: string, description: string, color: string }) {
    const messages: GptCompletionMessage[] = [
      {
        role: 'system',
        content: `You are a machine that only returns and replies with valid, iterable RFC8259 compliant JSON in your responses. Your text and punctuation should be compliant for white-space: pre-line.
         You are a social media expert helping a brand come up with an Ideal Creator Profile (ICP) for a campaign brief. The JSON object returned should have the following fields: 
         'creator_persona', 
         'creator_audience', 
         'creator_content_style', 
         'creator_engagement_metrics', 
         'creator_specific_characteristics'.

         In Addition to the JSON object, please return a paragraph of text that explains the creator profile in a way that is easy for a human to understand and read. The paragraph should ne an array of JSON objects with the format: 
         { sub_heading: string, paragraph: string }[].

         the overall JSON object should be like this: 
         {
         "paragraph": "...",
         "json": {
          "creator_persona": "...",
          "creator_audience": "...",
          "creator_content_style": "...",
          "creator_engagement_metrics": "...",
          "creator_specific_characteristics": "..."
         }
         }
         `
      },
      {
        "role": "user",
        "content": `Based on this campaign brief, recommend an ideal creator profile:

        Brand Name: ${brandName}
        Brief Title: ${briefTitle}
        Product: ${product}
        Goals: ${goal}

        Please provide a detailed creator profile recommendation including:
        - Audience demographics they should have
        - Content style and tone
        - Engagement metrics to look for
        - Specific characteristics that would make them ideal for this campaign`
      }
    ]

    const gpt_response: any = await firstValueFrom(this.chatGptService.sendCompletionMessage(messages));
    let gptProductResult: any = JSON.parse(gpt_response.choices[0].message.content);
    return gptProductResult;
  }
}
